<template>
    <div class="Home">
        <HomeBackground></HomeBackground>
        <HomeJobstream></HomeJobstream>
        <HomePresentation></HomePresentation>
        <HomePartenaire></HomePartenaire>
        <HomeAccomp></HomeAccomp>
    </div>
</template>

<script>
import HomeBackground from './HomeBackground.vue'
import HomeAccomp from './HomeAccomp.vue'
import HomeJobstream from './HomeJobstream.vue'
import HomePartenaire from './HomePartenaire.vue'
import HomePresentation from './HomePresentation.vue'

export default {
    name: "Home",
    components: {
        HomeBackground,
        HomeAccomp,
        HomeJobstream,
        HomePartenaire,
        HomePresentation
    }
}
</script>

<style scoped>

</style>